import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    exports: [],
    modal: false,
};

const getters = {
    exports(state) {
        return state.exports;
    },

    modal(state) {
        return state.modal;
    },
};

const mutations = {
    add(state, exports) {
        state.exports = [exports, ...state.exports];

        if (state.exports.length > 5) {
            state.exports.pop();
        }
    },

    set(state, exports) {
        state.exports = exports;
    },

    open(state) {
        state.modal = true;
        $('#exportDetailsModal').addClass('open');
    },

    close(state) {
        state.modal = false;
        $('#exportDetailsModal').removeClass('open');
    },
};

const actions = {
    /**
     * update the state with the passed value
     * @param {
     * {
     *      id: number;
     *      name: string;
     *      status: string;
     *      date: string;
     * }
     * } value
     */
    updateExports({ commit, dispatch }, value) {
        startLoading(dispatch, 'getExportsDetails');

        commit('add', value);

        endLoading(dispatch, 'getExportsDetails');
    },

    /**
     * fetch the latest data from the API and update the state
     * @param {*} param0
     */
    getLatestExportsDetails({ commit, dispatch }) {
        startLoading(dispatch, 'getExportsDetails');
        commit('open');
        //fetch the data from the API
        let route = Laroute.route('franchise.report.exportRequest.list');
        return axios
            .get(route)
            .then(res => {
                commit('set', res.data.data);
                endLoading(dispatch, 'getExportsDetails');
            })
            .catch(err => {
                endLoading(dispatch, 'getExportsDetails');
                throw err;
            });
    },

    /**
     * Update the exports detail api with the passed value
     * @param {
     *      * {
     *      id: number;
     *      name: string;
     *      status: string;
     *      date: string;
     * }
     * } value
     */
    addExportDetails({ commit, dispatch }, value) {
        commit('open');
        // handle add new export
        // update exports detail api
        dispatch('updateExports', value);
    },

    getDownloadableUrl({ commit, dispatch }, value) {
        let route = Laroute.route(
            'franchise.report.exportRequest.getDownloadableUrl',
            {
                export_request_id: value,
            },
        );
        return axios
            .get(route)
            .then(res => {
                return res.data.url;
            })
            .catch(err => {
                throw err;
            });
    },

    closeModal({ commit, dispatch }) {
        commit('close');
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
